import { Decimal } from "decimal.js";

export const formatInMillion = (number, fixedValue) => {
  if (!number) {
    return 0;
  }
  return (number / 1000000).toFixed(fixedValue);
};
export const formatInBillion = (number, fixedValue) => {
  if (!number) {
    return 0;
  }
  return (number / 1000000000).toFixed(fixedValue);
};
export const formatInThousands = (number, fixedValue) => {
  if (!number) {
    return 0;
  }
  return (number / 1000).toFixed(fixedValue);
};

export const formatNumberIntl = (number, decimals) => {
  if (number instanceof Decimal) {
    number = number.toNumber();
  }

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(number);
};

export const formatLargeNumber = (num, decimals = 1) => {
  const abbreviations = ['', 'K', 'M', 'B', 'T'];
  
  let tier = Math.floor(Math.log10(Math.abs(num)) / 3);
  tier = Math.min(tier, abbreviations.length - 1);
  
  const scaled = num / Math.pow(1000, tier);
  
  return scaled.toFixed(decimals).toLocaleString() + abbreviations[tier];
}
